'use client';

import { useTranslations } from 'next-intl';

import FormEmailToRegister from '@/app/_components/form-email-to-register';
import { cn } from '@/lib/utils';

interface RegisterBannerProps {
  className?: string;
}

const RegisterBanner = ({ className }: RegisterBannerProps) => {
  const t = useTranslations();
  return (
    <div
      className={cn(
        'mx-4 flex h-fit flex-col items-center justify-center self-center rounded-lg bg-foreground p-4 sm:inset-x-12 sm:bottom-12 sm:top-auto sm:flex-row sm:self-end sm:p-10 md:absolute md:inset-x-4 md:mx-auto',
        className,
      )}
    >
      <div className="mb-4 mr-0 flex flex-col items-center gap-2 text-center text-white sm:mb-0 sm:mr-8 sm:items-start sm:text-left">
        <p>{t('pages.project.registerBanner.mainParagraph')}</p>
      </div>
      <FormEmailToRegister
        lightVersion
        ctaLabel={t('pages.project.registerBanner.cta')}
      />
    </div>
  );
};

export default RegisterBanner;
